// TODO@rick this name should probably be review-specific...
// But beware of conflicts with reviews/actions/constants.js.
export const CLEAR_ALL_REALTIME_REVIEWS = 'CLEAR_ALL_REALTIME_REVIEWS';
export const REALTIME_UPDATE_REVIEW_RECEIVED = 'REALTIME_UPDATE_REVIEW_RECEIVED';
